import { noop } from '@kofno/piper';
import { Task } from 'taskarian';
import { errorMessage } from '../ExceptionHandling';

export interface SaveAsFailed {
  kind: 'save-as-failed';
  message: string;
}

// Starts a browser download of the blob.
const download = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  // Revoke later, so the download has started before the URL goes away.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
};

export const saveAsT =
  (fileName: string) =>
  (blob: Blob): Task<SaveAsFailed, Blob> =>
    new Task((reject, resolve) => {
      try {
        download(blob, fileName);
        resolve(blob);
      } catch (err) {
        reject({ kind: 'save-as-failed', message: errorMessage(err) });
      }
      return noop;
    });
